import * as ko from 'knockout';
import { Observable } from 'knockout';
import { locationsService } from '../../../api/service.locations';
import { dialog } from '../../app';
import { DialogParams, FieldType } from '../../elements/bp-dialog';
import { formatDateTime, formatWeight } from '../../../utils/format';

class AdminMovements {
  title: Observable<string>;
  movements: ko.ObservableArray<any>;

  readonly dialog: Observable<DialogParams | null>;
  readonly toast: Observable<string | null>;

  constructor(params: any) {
    this.title = ko.observable('Admin / All Movements');
    this.movements = ko.observableArray();

    this.dialog = ko.observable(null);
    this.toast = ko.observable(null);

    this.loadMovements();
  }

  loadMovements = () => {
    locationsService
      .getAllMovements()
      .then(movements => {
        const movementMap = movements.map(l => {
          return {
            ...l,
            time: formatDateTime(l.time),
            product: `${l.productName} ${formatWeight(l.unitWeight)}`,
            movement: `${l.fromLocation} -> ${l.toLocation}`,
          }
        });
        console.log(movementMap);
        this.movements(movementMap);
      })
      .catch(e => console.log(e));
  }
}

export default {
  name: 'bp-admin-movements',
  viewModel: AdminMovements,
  template: require('./movements.html')
};
